module.exports = __webpack_public_path__ + "static/media/021.29c982b1.jpg";